import { ReactNode } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Styles } from "./styled";

interface IProps {
  children: ReactNode;
  minScale?: number;
  maxScale?: number;
  initialScale?: number;
  enablePanning?: boolean;
}

const ZoomContainer = (props: IProps) => {
  const {
    children,
    minScale = 1,
    maxScale = 4,
    initialScale = 1,
    enablePanning = false,
  } = props;

  return (
    <Styles enablePanning={enablePanning}>
      <TransformWrapper
        initialScale={initialScale}
        minScale={minScale}
        maxScale={maxScale}
        centerOnInit
        wheel={{ step: 0.0005 }}
        doubleClick={{ disabled: true }}
        panning={
          enablePanning
            ? {
                disabled: false,
                velocityDisabled: true,
                excluded: ["button", "a", "input", "select", "textarea"],
              }
            : {
                disabled: true,
                excluded: ["zoom-container-content"],
              }
        }
        pinch={{
          disabled: false,
        }}
      >
        <TransformComponent
          wrapperStyle={{ width: "100%", height: "100%", background: "#fff" }}
          contentClass="zoom-container-content"
        >
          {children}
        </TransformComponent>
      </TransformWrapper>
    </Styles>
  );
};

export default ZoomContainer;
